import { msalRedirectURL, jllSSOIssuer,jllSSOClientId,jllSSORedirectUri } from "./config.js"


export const msalConfig = {
    auth: {
      clientId: "59d0c57f-e98f-4663-9c8e-f6afb0e48060",
      authority: "https://login.microsoftonline.com/699c624f-5a91-4e23-85f5-8e63c35f39f5",
      redirectUri: msalRedirectURL,
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["User.Read"]
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };

  export const jllSSOConfig = {
    clientId: jllSSOClientId,
    issuer: jllSSOIssuer,
    redirectUri: jllSSORedirectUri,
    pkce: true
  };